export const textFieldMobileStyles = {
  '.MuiInputBase-input': {
    fontSize: '14px',
    border: '1px solid #ddd',
    lineHeight: '16px',
    borderRadius: '8px',
  },
};

export const textFieldStyles = {
  '.MuiInputBase-input': {
    fontSize: '14px',
    fontFamily: 'Outfit, sans-serif',
    border: '1px solid #ddd',
    borderRadius: '8px',
  },
};

export const textAreaFieldMobileStyles = {
  '& .MuiInputBase-root': {
    borderRadius: '20px',
    padding: 0,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: 'Outfit, sans-serif',
  },

  '.MuiInputBase-input': {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
  },
};

export const textAreaFieldStyles = {
  '& .MuiInputBase-root': {
    borderRadius: '20px',
    padding: 0,
  },

  '.MuiInputBase-input': {
    fontSize: '24px',
    padding: '24px 37px',
  },
};

export const richEditorStyles = (isMobile: boolean) => ({
  width: '100%',
  marginBottom: isMobile ? '8px' : '0',
});
